import gql from "graphql-tag";

const personnelMutations = {


    createPersonnel: gql`
        mutation CreatePersonnel($number: String, $first_name: String, $last_name: String, $birth_name: String, $birth_date: DateTime, $entry_date: DateTime, $exit_date: DateTime, $type_of_remuneration: String, $remuneration_amount: String, $working_time_summer: String, $working_time_winter: String, $iban: String, $bic: String, $allowance: String, $meal_allowance_1: String, $meal_allowance_2: String, $total_reimbursement: String, $amount_per_km: String, $distance: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $profession_id: Int, $editor_id: Int, $user_id: Int) {
            createPersonnel(number: $number, first_name: $first_name, last_name: $last_name, birth_name: $birth_name, birth_date: $birth_date, entry_date: $entry_date, exit_date: $exit_date, type_of_remuneration: $type_of_remuneration, remuneration_amount: $remuneration_amount, working_time_summer: $working_time_summer, working_time_winter: $working_time_winter, iban: $iban, bic: $bic, allowance: $allowance, meal_allowance_1: $meal_allowance_1, meal_allowance_2: $meal_allowance_2, total_reimbursement: $total_reimbursement, amount_per_km: $amount_per_km, distance: $distance, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, profession_id: $profession_id, editor_id: $editor_id, user_id: $user_id) {
                id,
                number,
                first_name,
                last_name,
                birth_name,
                birth_date,
                entry_date,
                exit_date,
                type_of_remuneration,
                remuneration_amount,
                working_time_summer,
                working_time_winter,
                iban,
                bic,
                allowance,
                meal_allowance_1,
                meal_allowance_2,
                total_reimbursement,
                amount_per_km,
                distance,
                created_at,
                updated_at,
                deleted_at,
                profession_id,
                editor_id,
                user_id
            }
        }
    `,
    updatePersonnel: gql`
        mutation UpdatePersonnel($id: ID!, $number: String, $first_name: String, $last_name: String, $birth_name: String, $birth_date: DateTime, $entry_date: DateTime, $exit_date: DateTime, $type_of_remuneration: String, $remuneration_amount: String, $working_time_summer: String, $working_time_winter: String, $iban: String, $bic: String, $allowance: String, $meal_allowance_1: String, $meal_allowance_2: String, $total_reimbursement: String, $amount_per_km: String, $distance: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $profession_id: Int, $editor_id: Int, $user_id: Int) {
            updatePersonnel(id: $id, number: $number, first_name: $first_name, last_name: $last_name, birth_name: $birth_name, birth_date: $birth_date, entry_date: $entry_date, exit_date: $exit_date, type_of_remuneration: $type_of_remuneration, remuneration_amount: $remuneration_amount, working_time_summer: $working_time_summer, working_time_winter: $working_time_winter, iban: $iban, bic: $bic, allowance: $allowance, meal_allowance_1: $meal_allowance_1, meal_allowance_2: $meal_allowance_2, total_reimbursement: $total_reimbursement, amount_per_km: $amount_per_km, distance: $distance, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, profession_id: $profession_id, editor_id: $editor_id, user_id: $user_id) {
                id,
                number,
                first_name,
                last_name,
                birth_name,
                birth_date,
                entry_date,
                exit_date,
                type_of_remuneration,
                remuneration_amount,
                working_time_summer,
                working_time_winter,
                iban,
                bic,
                allowance,
                meal_allowance_1,
                meal_allowance_2,
                total_reimbursement,
                amount_per_km,
                distance,
                created_at,
                updated_at,
                deleted_at,
                profession_id,
                editor_id,
                user_id
            }
        }
    `,
};

export default personnelMutations;
